import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import * as fromUserSelectors from '../../store/selectors/user.selectors';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuard {
  private store = inject(Store);
  private router = inject(Router);

  isAuthenticated = false;
  constructor() {
    this.store.pipe(select(fromUserSelectors.selectLoaded)).subscribe((loaded) => {
      this.isAuthenticated = loaded;
    });
  }
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isAuthenticated ? true : this.router.createUrlTree(['onboarding', 'referral']);
  }
}
